import { Button, Link } from '@app/core';
import { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { InputLabel } from '@app/form';
import { t } from 'i18next';
import { Popover } from '@mui/material';

const useStyles = createUseStyles((theme: Theme) => ({
  menu: {
    '& .MuiPaper-root': {
      borderRadius: theme.borderRadius.std * 2,
    },
  },
  menuContent: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    maxWidth: theme.maxContentWidth.mediumBlock,
    minWidth: theme.maxContentWidth.smallBlock,
    maxHeight: theme.maxContentWidth.reducedFormContent,

    paddingTop: theme.marginBase * 3,
    paddingBottom: theme.marginBase * 3,

    gap: theme.marginBase,
  },
  scrollArea: {
    flex: 1,
    paddingLeft: theme.marginBase * 3,
    paddingRight: theme.marginBase * 3,
    overflowY: 'auto',
  },
  title: {
    ...theme.fonts.label,
    marginBottom: theme.marginBase,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase,
    backgroundColor: theme.colors.white,
    paddingLeft: theme.marginBase * 3,
    paddingRight: theme.marginBase * 3,
  },
  actionButton: {
    width: '100%',
  },
  boldText: {
    ...theme.fonts.label,
    color: theme.colors.inkSecondary,
  },
  clearLink: {
    ...theme.fonts.label,
    color: theme.colors.blueAccessible,
  },
}));

interface Props {
  title?: string | ReactNode;
  onClear?: () => any;
  onApply: () => any;
  anchorEl?: Element;
  onRequestClose: () => any;
  children?: ReactNode;
  clearOnTop?: boolean;
}
export const FilterPopover = ({
  title,
  onClear,
  anchorEl,
  onApply,
  onRequestClose,
  children,
  clearOnTop,
}: Props) => {
  const classes = useStyles();

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onRequestClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      className={classes.menu}
    >
      <div className={classes.menuContent}>
        <div className={classes.scrollArea}>
          <InputLabel
            label={title}
            rightAction={
              onClear &&
              !!clearOnTop && (
                <Link
                  type="button"
                  onClick={onClear}
                  className={classes.clearLink}
                >
                  {t(
                    'sessions.details.participationsDetails.fieldFilter.clear',
                  )}
                </Link>
              )
            }
          />

          {children}
        </div>
        <div className={classes.actions}>
          <Button
            className={classes.actionButton}
            variant="muted"
            small
            color="blue"
            type="button"
            text={t('sessions.details.participationsDetails.fieldFilter.apply')}
            onClick={onApply}
          />
          {onClear && !clearOnTop && (
            <Button
              className={classes.actionButton}
              variant="transparent"
              small
              color="blue"
              type="button"
              text={t(
                'sessions.details.participationsDetails.fieldFilter.clear',
              )}
              onClick={onClear}
            />
          )}
        </div>
      </div>
    </Popover>
  );
};
